import * as DashboardApiService from '../services/api/requests/Dashboard'

import {
  DASHBOARD_MERCHANTS,
  DASHBOARD_PASYAL_ARTICLES,
} from '../services/data/errorNames.json'

// data
const DASHBOARD_TOP_PICKS = { title: 'Top Picks' }
const DASHBOARD_WHATS_ON = {
  title: "What's On?",
  description: 'Check out events and happenings at Ayala Malls.',
}
const DASHBOARD_BEST_DEALS = {
  title: 'Best Deals',
  description: 'Discover limited-time offers at Ayala Malls.',
}
const DASHBOARD_PASYAL = {
  title: 'Pasyal',
  description:
    'Discover something new to see, shop, eat, and experience in Ayala Malls.',
}

// section titles and descriptions
export const doGetDashboardSections = () => {
  return {
    event: DASHBOARD_WHATS_ON,
    promo: DASHBOARD_BEST_DEALS,
    featured: DASHBOARD_TOP_PICKS,
    pasyal: DASHBOARD_PASYAL,
  }
}

// pasyal carousel items
export const doGetDashboardPasyal = ({
  setPasyalArticles,
  setError,
  errorList,
  removeError,
  onSuccess = () => {},
}) => async limit => {
  if (errorList.length) {
    removeError(DASHBOARD_PASYAL_ARTICLES)
  }

  await DashboardApiService.getPasyalArticles(limit)
    .then(response => {
      setPasyalArticles(response.data)
      onSuccess(response.data)
    })
    .catch(error => {
      setError({
        name: DASHBOARD_PASYAL_ARTICLES,
        error: error.message,
      })
    })
}

// explore carousel items
export const doGetDashboardExploreMerchants = ({
  setMerchants,
  setError,
  errorList,
  removeError,
  onSuccess = () => {},
}) => async limit => {
  if (errorList.length) {
    removeError(DASHBOARD_MERCHANTS)
  }
  await DashboardApiService.getAllMerchants(limit)
    .then(response => {
      setMerchants(response.data)
      onSuccess(response.data)
    })
    .catch(error => {
      setError({
        name: DASHBOARD_MERCHANTS,
        error: error.message,
      })
    })
}

// get hero banner homepage
export const doGetDashboardHeroBanner = async ({ setHeroBanner }) => {
  // setHeroBanner({})
  DashboardApiService.getHeroBanners()
    .then(response => {
      const heroBanner = response.data.find(
        banner => banner.screen === 'homepage',
      )

      setHeroBanner(heroBanner)
    })
    .catch(error => {
      console.log('do get dashboard hero banner catch error: ', error)
    })
}

// get hero banner promos and events
export const doGetDashboardHeroBannerPromosAndEvents = async ({
  setHeroBannerPromosAndEvents,
}) => {
  DashboardApiService.getHeroBanners()
    .then(response => {
      const heroBanner = response.data.find(
        banner => banner.screen === 'promos-and-events',
      )

      setHeroBannerPromosAndEvents(heroBanner)
    })
    .catch(error => {
      console.log(
        'do get dashboard hero banner promos and events catch error: ',
        error,
      )
    })
}
